import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";

const values = [
  {
    icon: "ri-book-open-line",
    title: "内容为本",
    desc: "以剧情介绍与资料整理为核心，帮助你快速了解每一部作品的故事内核。",
  },
  {
    icon: "ri-shield-check-line",
    title: "合规为先",
    desc: "本站不提供任何在线播放与下载资源，所有内容仅作信息介绍与交流用途。",
  },
  {
    icon: "ri-compass-3-line",
    title: "体验友好",
    desc: "清晰的分类与筛选，让你在大量作品中轻松找到想了解的那一部。",
  },
];

export default function AboutPage() {
  return (
    <div className="w-full">
      <div className="mx-auto w-full max-w-[1400px] px-4 pt-6 md:px-8 md:pt-8">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于" }]} />
      </div>

      <section className="mx-auto mt-4 w-full max-w-[1400px] px-4 md:px-8">
        <div className="rounded-lg bg-primary-950 px-6 py-12 md:px-12 md:py-16">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 px-3 py-1 text-xs font-medium text-accent-300">
            <i className="ri-information-line" />
            关于我们
          </span>
          <h1 className="mt-4 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-4xl">
            专注日韩伦理剧情影视的内容资料平台
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            日韩伦理片致力于为喜爱日韩伦理剧情影视作品的成年观众，提供系统、清晰的影片资料与剧情介绍，
            帮助你更好地理解作品、选择作品。我们不追热点营销，只做用心的内容整理。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${v.icon} text-xl`} />
              </span>
              <h2 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {v.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-4 pb-12 md:px-8">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8 lg:col-span-2">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="h-5 w-1 rounded-full bg-primary-500" />
              网站定位与内容说明
            </h2>
            <div className="mt-4 space-y-4 text-sm leading-loose text-foreground-700 md:text-base">
              <p>
                本站面向对日韩伦理剧情影视作品感兴趣的成年观众，主要提供影片的基本资料、主创信息、
                剧情摘要与相关推荐，帮助你在观看前对作品建立初步了解。
              </p>
              <p>
                站内所有片名、导演、主演及剧情简介均为示例内容，用于展示网站功能与页面结构，
                不代表任何真实作品的官方信息。我们尊重每一位创作者与版权方的合法权益。
              </p>
              <p>
                如你在使用过程中发现信息有误，或有任何建议，欢迎通过下方方式与我们取得联系。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-mail-line text-primary-600" />
              联系方式
            </h2>
            <ul className="mt-4 space-y-4 text-sm text-foreground-700">
              <li className="flex items-start gap-3">
                <i className="ri-mail-send-line mt-0.5 text-foreground-400" />
                <span>
                  邮箱反馈
                  <br />
                  <span className="text-foreground-900">contact@example.com</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-customer-service-2-line mt-0.5 text-foreground-400" />
                <span>
                  内容建议
                  <br />
                  <span className="text-foreground-900">建议通过站内搜索查找影片</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line mt-0.5 text-foreground-400" />
                <span>
                  响应时间
                  <br />
                  <span className="text-foreground-900">工作日 3 个工作日内回复</span>
                </span>
              </li>
            </ul>
            <Link
              to="/category"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-grid-line" />
              前往片库
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-4 pb-16 md:px-8">
        <div className="rounded-lg border border-accent-300 bg-accent-50 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-accent-900">
            <i className="ri-copyright-line" />
            版权及免责声明
          </h2>
          <div className="mt-4 space-y-3 text-xs leading-relaxed text-foreground-700 md:text-sm">
            <p>
              1. 本站为影视内容信息聚合与展示平台，<strong>不提供任何影片的在线播放、下载或资源链接</strong>，
              所有内容仅用于剧情介绍与影视资讯交流。
            </p>
            <p>
              2. 站内展示的片名、导演、演员、剧情简介等信息均为示例数据，若与真实作品存在雷同，纯属巧合。
            </p>
            <p>
              3. 本站内容仅面向成年观众。请理性浏览，遵守所在地法律法规与平台使用规范。
            </p>
            <p>
              4. 若相关权利人认为本站内容侵犯其合法权益，请通过上方联系方式告知，我们将及时核实并处理。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}